'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Jwt = require('./Jwt');

var _Jwt2 = _interopRequireDefault(_Jwt);

var _Storage = require('./Storage');

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utilities for working with stored refresh tokens
 * @namespace RefreshToken
 * @example
 * import { RefreshToken } from 'storis-jwt-auth';
 */
var RefreshToken = function RefreshToken() {
	(0, _classCallCheck3.default)(this, RefreshToken);
};

RefreshToken.exists = function () {
	return !!_Storage2.default.refreshToken.get();
};

RefreshToken.isExpired = function () {
	return RefreshToken.exists() ? _Jwt2.default.isTokenExpired(_Storage2.default.refreshToken.get()) : true;
};

RefreshToken.isAcceptable = function () {
	return _Jwt2.default.isTokenAcceptable(_Storage2.default.refreshToken.get());
};

RefreshToken.willExpireBefore = function (seconds) {
	return RefreshToken.exists() ? _Jwt2.default.willTokenExpireBefore(_Storage2.default.refreshToken.get(), seconds) : true;
};

RefreshToken.retrieve = function (url, _ref) {
	var idToken = _ref.idToken,
	    other = (0, _objectWithoutProperties3.default)(_ref, ['idToken']);
	var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
	var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { 'Content-Type': 'application/json' };

	if (_Jwt2.default.isTokenAcceptable(idToken)) {
		return fetch(url, { method: method, headers: headers, body: (0, _stringify2.default)((0, _extends3.default)({ idToken: idToken }, other)) }).then(function (response) {
			if (!response.ok) {
				throw new Error(response.statusText);
			}
			return response;
		}).then(function (response) {
			return response.json();
		}).then(function (_ref2) {
			var refreshToken = _ref2.refreshToken;

			if (!_Jwt2.default.isTokenWellFormed(refreshToken)) {
				throw new Error('malformed refresh token received');
			}
			// store our new refresh token and hit the callback
			_Storage2.default.identity.set(_Jwt2.default.getIdentity(idToken));
			_Storage2.default.refreshToken.set(refreshToken);
		});
	}
	return _promise2.default.reject(new Error('a valid id token is required'));
};

exports.default = RefreshToken;